export default __webpack_public_path__ + "static/media/chat.3259bb6f.png";